"use strict";

/* eslint-disable react/no-find-dom-node, react/jsx-handler-names */
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _colr = _interopRequireDefault(require("./vendor/colr"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var Board =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Board, _React$Component);

  function Board(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Board);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Board).call(this, props));
    var events = ['onBoardMouseDown', 'onBoardDrag', 'onBoardDragEnd'];
    events.forEach(function (m) {
      _this[m] = _this[m].bind((0, _assertThisInitialized2.default)(_this));
    });
    return _this;
  }

  (0, _createClass2.default)(Board, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousemove', this.onBoardDrag);
      window.removeEventListener('mouseup', this.onBoardDragEnd);
    }
  }, {
    key: "onBoardMouseDown",
    value: function onBoardMouseDown(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
      window.addEventListener('mousemove', this.onBoardDrag);
      window.addEventListener('mouseup', this.onBoardDragEnd);
    }
  }, {
    key: "onBoardDrag",
    value: function onBoardDrag(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
    }
  }, {
    key: "onBoardDragEnd",
    value: function onBoardDragEnd(e) {
      var x = e.clientX;
      var y = e.clientY;
      this.pointMoveTo({
        x: x,
        y: y
      });
      window.removeEventListener('mousemove', this.onBoardDrag);
      window.removeEventListener('mouseup', this.onBoardDragEnd);
    }
  }, {
    key: "measureBounds",
    value: function measureBounds() {
      return _reactDom.default.findDOMNode(this).getBoundingClientRect();
    }
  }, {
    key: "pointMoveTo",
    value: function pointMoveTo(pos) {
      var rect = this.measureBounds();
      var width = rect.width;
      var height = rect.height;
      var left = pos.x - rect.left;
      var top = pos.y - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, width);
      top = Math.max(0, top);
      top = Math.min(top, height);
      var hsv = {
        h: this.props.hue,
        s: left / width * 100,
        v: (1 - top / height) * 100
      };

      var hex = _colr.default.fromHsvObject(hsv).toHex();

      this.props.onChange({
        hex: hex
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          hex = _this$props.hex,
          hue = _this$props.hue;

      var _colr$fromHex$toHsvOb = _colr.default.fromHex(hex).toHsvObject(),
          s = _colr$fromHex$toHsvOb.s,
          v = _colr$fromHex$toHsvOb.v;

      var x = "calc(" + s + "% - 4px)";
      var y = "calc(" + (100 - v) + "% - 4px)";
      var hueHsv = [hue, 100, 100];

      var backgroundColor = _colr.default.fromHsvArray(hueHsv).toHex();

      return _react.default.createElement("div", {
        className: (0, _classNames.default)('private-react-colorpicker--panel-board-wrapper', className)
      }, _react.default.createElement("img", {
        src: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
      }), _react.default.createElement("div", {
        className: "private-react-colorpicker--panel-board"
      }, _react.default.createElement("div", {
        className: "private-react-colorpicker--hsv",
        style: {
          backgroundColor: backgroundColor
        }
      }, _react.default.createElement("div", {
        className: "private-react-colorpicker--value"
      }), _react.default.createElement("div", {
        className: "private-react-colorpicker--saturation"
      })), _react.default.createElement("span", {
        style: {
          left: x,
          top: y
        }
      }), _react.default.createElement("div", {
        className: "private-react-colorpicker--handler",
        onMouseDown: this.onBoardMouseDown
      })));
    }
  }]);
  return Board;
}(_react.default.Component);

exports.default = Board;
Board.propTypes = {
  className: _react.PropTypes.string,
  hex: _react.PropTypes.string,
  hue: _react.PropTypes.number,
  onChange: _react.PropTypes.func
};
module.exports = exports.default;